import React, { useState, useEffect, useRef } from 'react';
import { Styles } from '../../../../config/design/styles';
import { getDataTableLocalization } from "../../../../config/Translate";
import axios from "axios";
import { connect } from "trim-redux";
import MaterialTable from "material-table";
import { tableIcons } from "../../../../config/design/TableIcons";
import { TableCount, TablePage } from "../../../../config/Permissions";
import {currencySymbol, showTableDate, truncate} from "../../../../config/values";
import CurrencyFormat from "react-currency-format";
import { translate } from "../../../../config/lang";
import { Container, IconButton, Typography } from "@mui/material";
import {AddRounded, CheckBoxRounded, CreditCardRounded, RemoveCircleOutline, RemoveRounded} from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import { defaultVariables } from "../../../../config";
import { withStyles } from "@mui/styles";
import {useSnackbar} from "notistack";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";
import {useParams} from "react-router";
import AddTransactionDialog from "../../wallet/AddTransactionDialog";
import {useTranslation} from "react-i18next";
import {Trash,CreditCard} from "lucide-react";
import GetConfirmationButton from "../../../components/elements/GetConfirmationButton";

const Wallet = ({ classes, }) => {
    const { enqueueSnackbar } = useSnackbar();
    let { id } = useParams();
    const tableRef = useRef();
    const { t } = useTranslation();

    const [columns] = useState([
        { title: t('uniqueCode'), field: 'unique_code', filterPlaceholder: t('search') ,editable: 'never',},

        {
            field: 'type',
            editable: 'never',
            filtering: false,
            title: t('transactionType'),
            lookup: {
                "deposit":
                    <Typography style={{ color: "#38bf84" }}>
                         {t('deposit')}
                    </Typography>,
                "withdraw":
                    <Typography style={{ color: "#BF8230" }}>
                         {t('withdraw')}
                    </Typography>,
            },
        },
        {
            title: t('amount'),
            field: 'amount',
            editable: 'never',
            filterPlaceholder: t('search'),
            render: rowData => <CurrencyFormat value={rowData.amount} displayType={'text'} thousandSeparator={true} suffix={" " + currencySymbol} />
        },
        { title: t('transactionTrackingCode'), field: 'track_code', filterPlaceholder: t('search') },
        {
            title: t('description'),
            field: 'description' ,
            render: rowData => <Tooltip arrow title={rowData.description}>{truncate(rowData.description,20)}</Tooltip>
        },
        {
            title: t('status'),
            editable: 'never',
            field: 'status',
            filterPlaceholder: t('choose'),
            lookup: {
                confirmed: <Typography className="table-badge active">{t('confirmed')}</Typography>,
                pending: <Typography className="table-badge pending">{t('pending')}</Typography>,
                not_paid: <Typography className="table-badge inactive">{t("not_paid")}</Typography>,
            },
        },
        {
            title: t('created_at'),
            editable: 'never',
            field: 'created_at',
            render: rowData => (
                <Typography className={classes.dateTable}>
                    {showTableDate(rowData.created_at)}
                </Typography>
            )
        },
        {
            title: t('activity'),
            editable: 'never',
            field: 'activity',
            render: rowData => (
                <div style={{display:"flex",gap:5}}>
                    {["not_paid", "pending"].includes(rowData.status) && (
                        <GetConfirmationButton
                            handleAction={() => handleRemoveItem(rowData.id)}
                            question={t('doYouWanaDeleteItem')}
                            icon={<CheckBoxRounded/>}
                            tooltip={t('delete')}
                            loading={loading}
                            iconColor="primary"
                        >
                            <Trash className="lucide-icon-primary btn"/>
                        </GetConfirmationButton>
                    )}
                    {rowData.status === "pending" && (
                        <Button
                            onClick={() => handlePayedItem(rowData.id, rowData.track_code)}
                            startIcon={<CreditCard />}
                            color="secondary"
                            size="small"
                            variant="contained"
                        >
                            {t('paid')}
                        </Button>
                    )}
                </div>
            )
        },
    ]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(null);
    const [userId, setUserId] = useState(null);
    const [bankInfo, setBankInfo] = useState(null);
    const [amount, setAmount] = useState(null);

    const loadData = () => {
        tableRef.current && tableRef.current.onQueryChange();
    };

    const handleRemoveItem = (id) => {
        let data = new FormData();
        data.append('id', id);
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${localStorage.getItem('ACT')}`
            }
        };
        axios.post(`${defaultVariables.url}/wallets/remove-history`, data, config)
            .then(() => loadData())
            .catch(() => setLoading(false));
    };

    const handlePayedItem = (id, track_code) => {
        if (!track_code) {
            enqueueSnackbar(t('addRefrenceIdFirst'), { variant: 'warning' });
            return;
        }
        let data = new FormData();
        data.append('id', id);
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${localStorage.getItem('ACT')}`
            }
        };
        axios.post(`${defaultVariables.url}/wallets/paid`, data, config)
            .then(() => loadData())
            .catch(() => setLoading(false));
    };

    const onEditRow = (row) => {
        let data = new FormData();
        data.append('id', row.id);
        data.append('track_code', row.track_code);
        data.append('description', row.description);

        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${localStorage.getItem('ACT')}`
            }
        };
        axios.post(`${defaultVariables.url}/wallets/edit-history`, data, config)
            .then(() => {
                enqueueSnackbar(t('detailsSet'), { variant: 'success' });
                loadData();
            })
            .catch(() => {
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
            });
    };

    return (
        <>
            {loading ? <AppCardLoaderFields /> : (
                <div className="main-table">
                    <MaterialTable
                        parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
                        tableRef={tableRef}
                        icons={tableIcons}
                        title={
                            <div className="flex-direction">
                                <AddTransactionDialog
                                    user_id={userId}
                                    reload={loadData}
                                />
                                <Typography>
                                    <strong>{user} {/*{!!bankInfo ? <ViewUserBankInfo bank_info={bankInfo} /> : null}*/}</strong>
                                    {!!amount ? ` (${t('balance')} : ` : null}
                                    {!!amount ? <CurrencyFormat value={amount} displayType={'text'} thousandSeparator={true} suffix={" " + currencySymbol} /> : null}
                                    {!!amount ? ") " : null}
                                </Typography>
                            </div>

                        }
                        localization={getDataTableLocalization()}
                        columns={columns}
                        data={(query) =>
                            new Promise((resolve, reject) => {
                                const config = {
                                    headers: {
                                        Accept: 'application/json',
                                        Authorization: `Bearer ${localStorage.getItem('ACT')}`
                                    }
                                };
                                axios.get(`${defaultVariables.url}/wallets/getHistory/${id}?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`, config)
                                    .then(response => {
                                        const data = response.data[1].data.map(row => ({
                                            amount: row.amount,
                                            id: row.id,
                                            description: row.description,
                                            status: row.status,
                                            type: row.type,
                                            track_code: row.track_code,
                                            unique_code: row.unique_code,
                                            created_at: row.created_at,
                                        }));
                                        setUser(`${response.data[0].user.first_name} ${response.data[0].user.last_name}`);
                                        setUserId(response.data[0].user.id);
                                        setAmount(response.data[0].amount);
                                        setBankInfo(response.data[0].user);
                                        resolve({
                                            data,
                                            page: response.data[1].current_page - 1,
                                            totalCount: response.data[1].total,
                                        });
                                    })
                                    .catch(() => reject());
                            })
                        }
                        options={{
                            pageSize: TablePage,
                            pageSizeOptions: TableCount,
                            defaultExpanded: true,
                            search: false,
                        }}
                        editable={{
                            onRowUpdate: (newData, oldData) =>
                                new Promise(resolve => {
                                    onEditRow(newData);
                                    resolve();
                                }),
                        }}
                    />
                </div>
            )}
        </>
    );
};

const mapStateToProps = state => ({
    locale: state.locale,
});

export default withStyles(Styles)(connect(mapStateToProps)(Wallet));
